import React from "react";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import { Card, CardBody } from "../../../../../../_metronic/_partials/controls";
import ReactSelect from "react-select";

export default function TotalDonorCount({ donorCount, handleChangeParams }) {
  return (
    <Card style={{height: '180px'}}>
      <CardBody>
        <h3 className="h3">
          <PeopleAltIcon className="mr-1" />
          Total Donatur
        </h3>
        <ReactSelect
          name="donor_period_type"
          options={[
            { label: "Keseluruhan", value: "" },
            { label: "Bulan ini", value: "this_month" },
            { label: "Tahun ini", value: "this_year" }
          ]}
          defaultValue={{ label: "Keseluruhan", value: "" }}
          onChange={selected => {
            handleChangeParams(selected.value);
          }}
        />
        <div className="d-flex justify-content-end">
          <div className="h1 m-5">{donorCount}</div>
        </div>
      </CardBody>
    </Card>
  );
}
